(function () {
	// Match product-slider.js mobile breakpoint
	const MOBILE_MAX = 767;
	const instances = new Map();

	const toBoolean = (value) => value === true || value === "true";

	const initMulticolumnSliders = () => {
		document.querySelectorAll(".multicolumn").forEach((section) => {
			const enableMobile = toBoolean(section.dataset.enableMobileSlider);
			const wrapper = section.querySelector(".multicolumn-list__wrapper--mobile-slider");
			const swiperEl = wrapper?.querySelector(".multicolumn-mobile-swiper");
			if (!enableMobile || !wrapper || !swiperEl) return;

			const sectionId = wrapper.id;
			const isMobile = window.innerWidth <= MOBILE_MAX;
			const existing = instances.get(sectionId);

			if (!isMobile) {
				if (existing) {
					existing.destroy(true, true);
					instances.delete(sectionId);
				}
				return;
			}

			if (existing) return;

			const mobileColumns = Number(section.dataset.mobileColumns) || 1;
			const paginationEl = wrapper.querySelector(".multicolumn-mobile-pagination");
			const nextEl = wrapper.querySelector(".swiper-button-next");
			const prevEl = wrapper.querySelector(".swiper-button-prev");

			const swiper = new Swiper(swiperEl, {
				speed: 1100,
				slidesPerView: mobileColumns,
				spaceBetween: 0,
				keyboard: true,
				watchOverflow: true,
				mousewheel: {
					forceToAxis: true,
				},
				navigation:
					nextEl && prevEl
						? {
								nextEl,
								prevEl,
						  }
						: undefined,
				pagination: paginationEl
					? {
							el: paginationEl,
							clickable: true,
					  }
					: undefined,
			});

			instances.set(sectionId, swiper);
		});
	};

	document.addEventListener("DOMContentLoaded", initMulticolumnSliders);
	document.addEventListener("shopify:section:load", initMulticolumnSliders);
	document.addEventListener("shopify:section:unload", (event) => {
		const wrapper = event.target.querySelector?.(".multicolumn-list__wrapper--mobile-slider");
		if (!wrapper) return;
		const instance = instances.get(wrapper.id);
		if (instance) {
			instance.destroy(true, true);
			instances.delete(wrapper.id);
		}
	});

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(initMulticolumnSliders, 200);
	});
})();
